export default {
    methods: {
        tokenize(input) {
            const tokens = [];
            const tokenRegex = /\s*(=>|:=|[{}();]|[a-zA-Z_]\w*|\d+|\S)\s*/g;
            let match;
            while ((match = tokenRegex.exec(input))) {
                tokens.push({ key: match[1], value: match[0] });
            }

            return tokens;
        },

        parse(tokens) {
            let index = 0;

            function peek() {
                const peek_pos = index + 1;
                if (peek_pos > tokens.length - 1)
                    return undefined;

                return tokens[peek_pos];
            }

            function parseStatements() {
                const statements = [];
                while ((index < tokens.length) &&  tokens[index].key !== 'end') {
                    statements.push(parseStatement());
                }
                
                index++; // skip "end"
                return statements;
            }

            function parseStatement() {
                if ((index < tokens.length) &&  tokens[index].key === 'if') {
                    return parseIf();
                } else if (peek()?.key === ':=') {
                    return parseAssignment();
                } else if ((index < tokens.length) &&  tokens[index].key === ';') {
                    index++;
                    return parseStatement();
                } else {
                    const name = tokens[index++].value;
                    const params = [];
                    while ((index < tokens.length) &&  tokens[index].key !== ';') {
                        params.push(tokens[index]);
                        index++;
                    }
                    
                    clearSeparator();
                    return {
                        type: 'Statement',
                        name,
                        params
                    }
                }
            }

            function parseIf() {
                index++; // skip "if"
                const conditions = [];
                while ((index < tokens.length) &&  tokens[index].key !== 'then') {
                    conditions.push(tokens[index++]);
                }
                index++; // skip "then"

                const body = [];
                while ((index < tokens.length) &&  tokens[index].key !== 'endif') {
                    body.push(parseStatement());
                }
                index++; // skip "endif"

                clearSeparator();
                return {
                    type: 'IfStatement',
                    conditions,
                    body
                };
            }

            function clearSeparator() {
                while ((index < tokens.length) &&  tokens[index].key === ';') {
                    index++; // skip ";"
                }
            }
    
            function parseAssignment() {
                const variable = tokens[index++];
                index++; // skip ":="
                const value = tokens[index++];

                clearSeparator();
                return {
                    type: 'AssignmentExpression',
                    variable,
                    value,
                };
            }

            const ast = [];
            while (index < tokens.length) {
                if (tokens[index].key === 'begin') {
                    index++; // skip "begin"
                    ast.push(parseStatements());
                } else {
                    index++; // skip other tokens
                }
            }

            return ast.flat();
        },

        compile(pascalCode) {
            const tokens = this.tokenize(pascalCode);
            const ast = this.parse(tokens);
            return ast;
        }
    }
}